// extracted by mini-css-extract-plugin
export default {"roadMapItem":"RoadMapItem_roadMapItem__e7UtU","roadMapBoxItem":"RoadMapItem_roadMapBoxItem__0hMo8","roadMapItemTitle":"RoadMapItem_roadMapItemTitle__ACggu"};